// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wf_a bhp_b","TwoDimsListFeature__item":"wf_b bhp_we","TwoDimsListFeature__item__text":"wf_c bhp_vt"};